import { Box } from "@mui/material";
import UnlistedEquityForm from "./unlistedEquityForm";
import AifForm from "./aifForm";
import PmsForm from "./pmsForm";
import BondsForm from "./bondsForm";
import MarginMoneyForm from "./marginMoneyForm";
import CorpusInOutForm from "./corpusInOutForm";
import {
    GetCounterPartyListResponseBody,
    GetNonMfBrokersListResponseBody,
} from "../../../../redux-store/types/orderManagement";
import {
    Dispatch,
    SetStateAction
} from "react";

export default function OrderDetailsForm({
    productType,
    securitiesData,
    fetchSecuritiesData,
    nonMfBrokersList,
    fetchNonMfBrokers,
    setValidations,
    counterPartyList,
    fetchCounterPartyList,
    isLoading,
    setLoadingStatus
}: {
    productType: string;
    securitiesData: Record<string, any>;
    fetchSecuritiesData: (searchInput: string) => void;
    nonMfBrokersList: GetNonMfBrokersListResponseBody;
    fetchNonMfBrokers: (searchInput: string) => void;
    setValidations: (values: Record<string, any>) => void;
    counterPartyList: GetCounterPartyListResponseBody;
    fetchCounterPartyList: (searchInput: string) => void;
    isLoading: boolean;
    setLoadingStatus: Dispatch<SetStateAction<"" | "apiLoading" | "formSubmitting">>
}): JSX.Element {
    switch (productType) {
        case "Unlisted Equity":
            return (
                <UnlistedEquityForm
                    securitiesData={securitiesData}
                    fetchSecuritiesData={fetchSecuritiesData}
                    setValidations={setValidations}
                    isLoading={isLoading}
                    setLoadingStatus={setLoadingStatus}
                    counterPartyList={counterPartyList}
                    fetchCounterPartyList={fetchCounterPartyList}
                />
            )
        case "AIF":
            return (
                <AifForm
                    securitiesData={securitiesData}
                    fetchSecuritiesData={fetchSecuritiesData}
                    setValidations={setValidations}
                    isLoading={isLoading}
                />
            )
        case "PMS":
            return (
                <PmsForm
                    securitiesData={securitiesData}
                    fetchSecuritiesData={fetchSecuritiesData}
                    setValidations={setValidations}
                    isLoading={isLoading}
                />
            )
        case "Bonds":
            return (
                <BondsForm
                    securitiesData={securitiesData}
                    fetchSecuritiesData={fetchSecuritiesData}
                    setValidations={setValidations}
                    nonMfBrokersList={nonMfBrokersList}
                    fetchNonMfBrokers={fetchNonMfBrokers}
                    counterPartyList={counterPartyList}
                    fetchCounterPartyList={fetchCounterPartyList}
                    setLoadingStatus={setLoadingStatus}
                    isLoading={isLoading}
                />
            )
        case "Margin Money":
            return (
                <MarginMoneyForm
                    nonMfBrokersList={nonMfBrokersList}
                    fetchNonMfBrokers={fetchNonMfBrokers}
                    isLoading={isLoading}
                    setLoadingStatus={setLoadingStatus}
                />
            )
        case "Corpus In/Out":
            return (
                <CorpusInOutForm isLoading={isLoading} />
            )
        default:
            return <Box />;
    }
}